import { useCallback, useState } from 'react';

import useEventListener from 'hooks/utils/useEventListener';
import { useIsomorphicLayoutEffect } from 'hooks/utils/useIsomorphicLayoutEffect';

type UseMapAutoScaleReturn = {
    svgRef: React.Dispatch<React.SetStateAction<SVGGElement | null>>;
    viewBox: string;
    scaleFactor: number;
};

export const useMapAutoScale = (): UseMapAutoScaleReturn => {
    const [ref, setRef] = useState<SVGGElement | null>(null);

    const [viewBox, setViewBox] = useState('0 0 0 0');
    const [scaleFactor, setScaleFactor] = useState(0.2);

    const BBox = ref?.getBBox();
    const BoundingClientRect = ref?.getBoundingClientRect();

    const handleResize = useCallback(() => {
        if (BBox && BoundingClientRect) {
            setScaleFactor(
                (BBox.height, BBox.width) /
                    (BoundingClientRect.height, BoundingClientRect.width)
            );
        }
    }, [BBox, BoundingClientRect]);

    const setViewBoxDimensions = useCallback(() => {
        if (BBox) {
            setViewBox(`${BBox.x} ${BBox.y} ${BBox.width} ${BBox.height}`);
        }
    }, [BBox]);

    useEventListener('resize', handleResize);

    useIsomorphicLayoutEffect(() => {
        handleResize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);

    useIsomorphicLayoutEffect(() => {
        setViewBoxDimensions();
    }, [setViewBoxDimensions]);

    return {
        svgRef: setRef,
        viewBox,
        scaleFactor,
    };
};
